import { object, string } from 'yup';

import { messages, regExEmail, trim } from '../../../../data/utils/form.utils';

export const schema = object()
  .shape({
    email: string()
      .transform(trim)
      .email(messages.invalidEmail.id)
      .matches(regExEmail, messages.invalidRegEx.id)
      .required(messages.required.id)
      .default(''),
    password: string()
      .transform(trim)
      .required(messages.required.id)
      .default(''),
  })
  .required()
  .noUnknown();
